import { styled } from "@xstyled/styled-components";

import { Button, Card, Text } from "@otta/design";

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: lg;
`;

export const VideoTipsAccess = ({
  text,
  ctaText,
  ctaAnalyticsId,
  onCTAClick,
  testId,
}: {
  text: string;
  ctaText: string;
  ctaAnalyticsId: string;
  onCTAClick: () => void;
  testId?: string;
}) => {
  return (
    <StyledCard data-testid={testId}>
      <Text>{text}</Text>
      <Button
        level="secondary"
        onClick={onCTAClick}
        data-testid={ctaAnalyticsId}
        data-analytics-id={ctaAnalyticsId}
      >
        {ctaText}
      </Button>
    </StyledCard>
  );
};
